import { defineMessages } from 'react-intl'

export const lang = defineMessages({
    title: {
        id: 'modal.status.success.title',
        defaultMessage: 'Card application submitted',
    },
    subtitle: {
        id: 'modal.status.success.subtitle',
        defaultMessage: 'Your request has been received and is being processed',
    },
    button: {
        id: 'modal.status.success.button',
        defaultMessage: 'Great!',
    },
})
